// @flow
// Used for IBs that use the <PaymentMethodPicker /> component to dynamically inject values
import type {Server} from 'docs/data/integration-builder';

const stringsWithSpaces = (
  pms: Array<string>,
  spaces: number,
  doubleQuote = false,
) =>
  pms.map(
    (pm) =>
      `${new Array(spaces).fill(' ').join('')}${doubleQuote ? '"' : "'"}${pm}${
        doubleQuote ? '"' : "'"
      },`,
  );

const java = (pms) =>
  pms.map(
    (pm) =>
      `${new Array(12)
        .fill(' ')
        .join(
          '',
        )}.addPaymentMethodType(SessionCreateParams.PaymentMethodType.${pm.toUpperCase()})`,
  );
export const formatPaymentMethods = (
  language: ?Server,
  pms: Array<string>,
  isNext: boolean,
): Array<string> => {
  if (isNext) {
    return stringsWithSpaces(pms, 10);
  }
  switch (language) {
    case 'node':
      return stringsWithSpaces(pms, 6);
    case 'ruby':
      return stringsWithSpaces(pms, 6);
    case 'python':
      return stringsWithSpaces(pms, 14);
    case 'php':
      return stringsWithSpaces(pms, 4);
    case 'dotnet':
      return stringsWithSpaces(pms, 18, true);
    case 'go':
      return stringsWithSpaces(pms, 6, true);
    case 'java':
      return java(pms);
    default:
      return [''];
  }
};
